/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Scroll from '@/components/Base/Scroll/indexBeta';
import SearchBar from '@/components/SearchBar';
import { getCustomerProductList, getCustomerProductionService, getV2FiledSortTmplFieldList } from '@/api';
import ExtFieldPc from '@/components/ExtFieldPc';
export default {
  name: 'CustomerProductList',
  components: {
    ViewBox: ViewBox,
    Scroll: Scroll,
    SearchBar: SearchBar,
    ExtFieldPc: ExtFieldPc
  },
  data: function data() {
    return {
      searchForm: {
        linkPerson: '',
        linkPhone: '',
        customerName: '',
        type: '1'
      },
      orderList: [],
      orderCount: 0,
      pageIndex: 0,
      pageSize: 10,
      showList: [],
      codeMap: {}
    };
  },
  computed: {
    sysList: function sysList() {
      var _this = this;
      var list = [{
        name: i18n.tc("197"),
        key: 'production_sn',
        auth: 'customerProduct_num',
        code: 420012
      }, {
        name: i18n.tc("198"),
        key: 'customer_name',
        auth: 'customerProduct_customer',
        code: 420013
      }, {
        name: i18n.tc("199"),
        key: 'qr_code',
        auth: 'customerProduct_qrCode',
        code: 420015
      }, {
        name: i18n.tc("200"),
        key: 'warranty_start_date',
        auth: 'p_warranty_start_date_view',
        code: 420002
      }, {
        name: i18n.tc("201"),
        key: 'warranty_end_date',
        auth: 'p_warranty_end_date_view',
        code: 420001
      }, {
        name: i18n.tc("202"),
        key: 'purchasing_date',
        auth: 'p_purchasing_date_view',
        code: 420006
      }, {
        name: i18n.tc("203"),
        key: 'delivery_date',
        auth: 'p_delivery_date_view',
        code: 420004
      }, {
        name: i18n.tc("204"),
        key: 'install_date',
        auth: 'p_install_date_view',
        code: 420005
      }, {
        name: i18n.tc("205"),
        key: 'production_date',
        auth: 'p_production_date_view',
        code: 420003
      }];
      return list.filter(function (v) {
        return _this.codeMap[v.code];
      });
    }
  },
  methods: {
    goLink: function goLink(item) {
      this.$router.push({
        name: 'CustomerProductDetail',
        params: {
          cpId: item.id
        }
      });
    },
    loadList: function loadList() {
      var _this2 = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
        this.$refs['orderList'] && this.$refs['orderList'].scrollToTop();
      }
      return new Promise(function (resolve, reject) {
        var data = _objectSpread({
          pageIndex: _this2.pageIndex,
          pageSize: _this2.pageSize
        }, _this2.searchForm);
        getCustomerProductList(data).then(function (list) {
          var orderList = list.data || [];
          if (!reset) {
            _this2.orderList = [].concat(_toConsumableArray(_this2.orderList), _toConsumableArray(orderList));
          } else {
            _this2.orderList = orderList;
            setTimeout(function () {
              _this2.$vux.loading.hide();
            }, 300);
          }
          resolve();
          // 判断是否有新数据
          if (list.data.length <= _this2.pageSize) {
            _this2.$refs['orderList'] && _this2.$refs['orderList'].isHasMore(true);
          } else {
            _this2.$refs['orderList'] && _this2.$refs['orderList'].isHasMore(false);
          }
        });
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      this.loadList(true);
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      this.pageIndex = this.pageIndex + 1;
      this.loadList();
    },
    resetList: function resetList() {
      this.searchForm.keyword = '';
      this.loadList(true);
    }
  },
  created: function created() {
    var _this3 = this;
    getCustomerProductionService().then(function (res) {
      if (res.success) {
        res.data.forEach(function (val) {
          _this3.$set(_this3.codeMap, val.code, val.value);
        });
      }
    });
    getV2FiledSortTmplFieldList({
      type: 42
    }).then(function (res) {
      if (res.success) {
        _this3.showList = res.data.filter(function (v) {
          return v.is_view;
        }).map(function (v) {
          return v.field_key;
        });
      }
    });
    this.loadList();
  }
};